import { render, staticRenderFns } from "./workpackage-settings-modal.vue?vue&type=template&id=5b903c14&scoped=true"
import script from "./workpackage-settings-modal.vue?vue&type=script&lang=js"
export * from "./workpackage-settings-modal.vue?vue&type=script&lang=js"
import style0 from "./workpackage-settings-modal.vue?vue&type=style&index=0&id=5b903c14&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b903c14",
  null
  
)

export default component.exports